// Modules
import React from "react";

const CarpetIcon = (props) => {
  return (
    <svg
      height="1em"
      viewBox="0 0 512 512"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M496,136a8,8,0,0,0,0-16h-8V104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16h8v16H16a8,8,0,0,0,0,16H496a8,8,0,0,0,0-16h-8V392h8a8,8,0,0,0,0-16h-8V360h8a8,8,0,0,0,0-16h-8V328h8a8,8,0,0,0,0-16h-8V296h8a8,8,0,0,0,0-16h-8V264h8a8,8,0,0,0,0-16h-8V232h8a8,8,0,0,0,0-16h-8V200h8a8,8,0,0,0,0-16h-8V168h8a8,8,0,0,0,0-16h-8V136ZM312,104h16v76.92l-16-16Zm-96,0h80v44.92l-34.34-34.34a8.015,8.015,0,0,0-11.32,0L216,148.92Zm-32,0h16v60.92l-16,16ZM48,408H40V104h8Zm120,0H64V104H168v92.92l-53.42,53.42a8,8,0,0,0,0,11.32L168,315.08Zm32,0H184V331.08l16,16Zm96,0H216V363.08l34.34,34.34a8.015,8.015,0,0,0,11.32,0L296,363.08Zm32,0H312V347.08l16-16Zm-72-27.55L131.55,256,256,131.55,380.45,256ZM448,408H344V315.08l53.42-53.42a8,8,0,0,0,0-11.32L344,196.92V104H448Zm24,0h-8V104h8Z"/>
    </svg>
  );
};

export default CarpetIcon;
